import CryptoJS from 'crypto-js';

// Clave secreta para encriptación
// En producción, debería venir de process.env.REACT_APP_STORAGE_SECRET
const SECRET_KEY = process.env.REACT_APP_STORAGE_SECRET || 'retenciones-secure-key-v1';
const PREFIX = 'secure_';

/**
 * Servicio de almacenamiento seguro para LocalStorage
 * Encripta los datos sensibles antes de guardarlos
 */
const storageService = {
    /**
     * Guardar datos encriptados
     * @param {string} key - Clave del item
     * @param {any} value - Valor a guardar (objeto, string, número)
     */
    setItem: (key, value) => {
        try {
            if (value === null || value === undefined) return;

            const jsonValue = JSON.stringify(value);
            const encryptedValue = CryptoJS.AES.encrypt(jsonValue, SECRET_KEY).toString();

            localStorage.setItem(`${PREFIX}${key}`, encryptedValue);
        } catch (error) {
            console.error('Error saving to storage:', error);
        }
    },

    /**
     * Obtener y desencriptar datos
     * @param {string} key - Clave del item
     * @returns {any} Valor desencriptado o null si no existe/error
     */
    getItem: (key) => {
        try {
            const encryptedValue = localStorage.getItem(`${PREFIX}${key}`);
            if (!encryptedValue) return null;

            const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
            const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

            if (!decryptedString) return null;

            return JSON.parse(decryptedString);
        } catch (error) {
            console.error('Error reading from storage:', error);
            // Si falla la desencriptación (ej. clave cambió), limpiar item corrupto
            localStorage.removeItem(`${PREFIX}${key}`);
            return null;
        }
    },

    /**
     * Eliminar item
     * @param {string} key - Clave del item
     */
    removeItem: (key) => {
        localStorage.removeItem(`${PREFIX}${key}`);
    },

    /**
     * Limpiar todo (útil para logout)
     */
    clear: () => {
        // Solo limpiar items con nuestro prefijo para no afectar otras apps en localhost
        Object.keys(localStorage).forEach((k) => {
            if (k.startsWith(PREFIX)) {
                localStorage.removeItem(k);
            }
        });
    }
};

export default storageService;
